import { useState } from "react";
import "./Input.css";
interface inputProps {
  disabled: boolean;
  inputType: string;
  name?: string;
  errorMessage?: string | undefined | string[];
  iserror?: boolean;
  value?: string | number;
  label?: string;
  inputRegex?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
   placeholder?: string;
}
export const Input = ({
  inputType,
  disabled,
  name,
  errorMessage,
  value,
  label,
  iserror,
  onChange,
  onBlur,
  placeholder,
}: inputProps) => {
  // const [error, setError] = useState(false);
  return (
    <>
      <div
        className="input-group"
        style={disabled ? { pointerEvents: "none", opacity: 0.4 } : {}}
      >
        <div className="input-wrapper-label">
          <label className="input-label">
            <p>{label}</p>
          </label>
        </div>
        {/* <div className="input-spacer"></div> */}
        <div className="input-wrapper-textbox">
          <input
            // pattern={inputRegex && inputRegex}
            style={{
              border: iserror ? "1.5px solid red" : undefined,
            }}
             placeholder={placeholder}
            type={inputType}
            name={name}
            value={value}
            className="input-textbox"
            onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault(); // prevent keyboard increment/decrement
              }
            }}
            onChange={disabled ? undefined : onChange}
            onBlur={onBlur}
          ></input>
          {iserror && <div className="input-error">{errorMessage}</div>}
        </div>
      </div>
    </>
  );
};

{
  /* <input
        type={inputType}
        name={name}
        value={value}
        className="input"
        onChange={disabled ? undefined : onChange}
        onBlur={onBlur}></input>
      {!disabled && <label className="user-label">{label}</label>}
      <label className="user-label">{label}</label>
      {iserror && <div className="error">{errorMessage}</div>} */
}
